export default "__VITE_ASSET__AMX9enko__"